/**
 * API URL utilities for handling different environments
 */

/**
 * Get the correct API base URL based on the current environment
 * In development, uses the Vite dev server (localhost:5173) which proxies to Pages Functions
 * In production, uses the same host as the frontend
 */
export function getApiBaseUrl(): string {
  if (window.location.hostname === 'localhost') {
    return 'http://localhost:5173'
  }
  return `${window.location.protocol}//${window.location.host}`
}

/**
 * Get the full API URL for a given endpoint
 */
export function getApiUrl(endpoint: string): string {
  const baseUrl = getApiBaseUrl()
  // Ensure endpoint starts with /
  const cleanEndpoint = endpoint.startsWith('/') ? endpoint : `/${endpoint}`
  return `${baseUrl}${cleanEndpoint}`
}

/**
 * Get the WebSocket URL for game connections
 * In development, connects directly to GameRoom worker for WebSocket
 * In production, uses the same host (Cloudflare handles routing)
 */
export function getWebSocketUrl(roomCode: string): string {
  const protocol = window.location.protocol === 'https:' ? 'wss:' : 'ws:'
  const host = window.location.hostname === 'localhost' ? 'localhost:8787' : window.location.host
  return `${protocol}//${host}/game/${roomCode}`
}
